<template>
	<div>
		<ValidationObserver ref="formModalValidate">
			<b-row>
				<b-col cols="12">
					<ValidationProvider name="course_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('course')" class="mb-1">
                            <ValidationProvider name="course_id" rules="required" v-slot="{ errors }">
                                <course-auto-complete v-model="formData.course_id"
                                                      :valueObject="{ value:formData.course_id}"
                                                      :validate-error="errors[0]"/>
                            </ValidationProvider>
                        </b-form-group>
					</ValidationProvider>
				</b-col>
				<b-col cols="12">
					<b-form-group :label="$t('name')">
						<ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
								<b-form-input v-model="formData.name"
								              :state="errors[0] ? false : null"/>
							<b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
						</ValidationProvider>
					</b-form-group>
				</b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('status')">
                        <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                                <StatusSelectbox v-model="formData.status" :validate-error="errors[0]" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('Parent')">
                        <ValidationProvider name="parent_id" rules="" v-slot="{valid, errors}">
                             <CourseTopicSelectbox v-model="formData.parent_id" :validate-error="errors[0]"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

			</b-row>
			<div class="d-flex justify-content-center mt-2">
				<b-button variant="primary"
				          @click="createForm"
				          :disabled="formLoading">
					{{ $t('save') }}
				</b-button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
	// Components
	import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";

	// Services

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"
    import CourseTopicSelectbox from "@/components/interactive-fields/CourseTopicSelectbox.vue";
    import CourseTopicsService from "@/services/CourseTopicsService";

	export default {
		components: {
            CourseTopicSelectbox,
			StatusSelectbox,

			ValidationProvider,
			ValidationObserver,
		},
		data() {
			return {
				formData: {

				},
				formLoading: false,
			}
		},
		methods: {
			async createForm() {
                if(this.checkPermission('coursetopic_store')) {
                    const isValid = await this.$refs.formModalValidate.validate();
                    if (isValid) {
                        this.formLoading = true;
                        CourseTopicsService.store(this.formData)
                                     .then(response => {
                                         this.$toast.success(this.$t('api.' + response.data.message));
                                         this.$emit('createFormSuccess', true);
                                     })
                                     .catch(e => {
                                         this.showErrors(e, this.$refs.formModalValidate);
                                     })
                                     .finally(() => {
                                         this.formLoading = false
                                     })
                    }
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
			}
		}
	}
</script>

